import { createAction } from 'redux-actions';
export var setStep = createAction('REFUND/STEPS/SET_STEP');
export var setSteps = createAction('REFUND/STEPS/SET_STEPS');
export var nextStep = createAction('REFUND/STEPS/NEXT_STEP');
export var prevStep = createAction('REFUND/STEPS/PREV_STEP');
